module.exports = "/_next/static/images/slide1-6bc47c07fac5fd7a062edb899aedf9ff.jpg.webp";